<div class="docs-section" id="errors">
  <div class="docs-section__head">
    <h1 class="docs-h1">Errors</h1>
    <p class="docs-subtitle">
      Every error comes back in the same envelope. Switch on <code class="docs-param">code</code>, never on the
      message text.
    </p>
  </div>

  <div class="docs-code-panel docs-errors__envelope">
    <pre class="docs-code-pre">{{ envelope }}</pre>
  </div>

  <ul class="docs-errors">
    @for (e of errors; track e.code) {
      <li class="docs-errors__item">
        <div class="docs-errors__head">
          <span class="docs-errors__status" [class.docs-errors__status--server]="e.status >= 500">
            {{ e.status }} <span class="docs-errors__reason">{{ reasonOf(e.status) }}</span>
          </span>
          <code class="docs-errors__code">{{ e.code }}</code>
        </div>
        <p class="docs-errors__meaning">{{ e.meaning }}</p>
      </li>
    }
  </ul>
</div>
